import React from "react";
import RaindropCard from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";

const StratusAboutUs = () => {
  return (
    <div
      id={"page--about-us"}
      className="flex flex-col w-full py-32 justify-center items-center "
    >
      <div className="flex flex-col w-full max-w-2xl gap-6   ">
        <h1 className="text-4xl font-black w-full text-center">About Us</h1>

        <RaindropCard>
          <RaindropTextParagraph>
            <div className="flex flex-col gap-6">
              <p>Hi there</p>
              <p>I'm Rhaz, the founder of The Raindrop Company.</p>
              <p>
                Currently, the project is small — just a single software
                engineer with a big dream. I genuinely believe we all have an
                innate desire to do good and be kind, all we have to do is
                release that latent potential by making the process as easy as
                possible.
              </p>
              <p>
                The idea for The Raindrop Company emerged from my personal
                frustrations with charitable giving. While the work of
                non-profits around the world is nothing short of incredible, the
                process of donating to them has become too cumbersome and
                opaque.
              </p>
              <p>
                Will I be able to cancel my contribution easily? Will I be
                bombarded with emails I can't unsubscribe from? Can I trust that
                this organization is legitimate? Will my money actually go to
                the cause I care about? Will I be able to adjust my contribution
                if needed?
              </p>
              <p>
                I aim to address these concerns by building a high-trust,
                transparent platform for charitable giving. We are committed to
                being relentlessly kind to those willing to give their own money
                to help others. Our platform allows users to cancel with just a
                few clicks, trust the organizations they support, and easily
                adjust their contributions as needed.
              </p>
              <p>
                The Raindrop app is currently in Beta, with a public release
                planned for later this year.
              </p>

              <div>
                <p className="font-bold">Rhaz Solomon</p>
                <p>Founder</p>
              </div>
            </div>
          </RaindropTextParagraph>
        </RaindropCard>
      </div>
    </div>
  );
};

export default StratusAboutUs;
